export const BASE_URL = '' // BECAUSE OF GITHUBPAGES
export const CHORD_VIEWER_BASE_ROUTE = BASE_URL + "/chordViewer";
export const PARTITION_LIST_BASE_ROUTE = BASE_URL + "/partitionList";
export const PARTITION_BASE_ROUTE = BASE_URL + "/partition";
export const PARTITION_EDITOR_BASE_ROUTE = BASE_URL + "/partition/editor";
export const NEW_PARTITION_BASE_ROUTE = BASE_URL + "/newPartition"